import { textSm } from '@insify/design-system/typography';

import { HTML_TAGS } from '../../../utils/markdown';

import type { ClassAttributes, ElementType, HTMLAttributes } from 'react';
import type { Components, ExtraProps } from 'react-markdown';

export function generateMarkdownComponents(): Components {
  const components: Components = {};

  HTML_TAGS.forEach((tag) => {
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const Component: ElementType = tag as ElementType;
      if (Component) {
        const fn: ElementType<ClassAttributes<HTMLElement> & HTMLAttributes<HTMLElement> & ExtraProps> = (props) => {
          const { children, id, className } = props;
          const { node: _node, ref: _ref, ...componentProps } = props;
          switch (tag) {
            case 'table':
            case 'input':
            case 'hr':
            case 'img':
              return (
                <Component className={className} {...componentProps} key={`${tag}-${id}`}>
                  {children}
                </Component>
              );
            case 'tr':
            case 'th':
            case 'td':
            case 'pre':
            case 'code':
              return <Component {...componentProps}>{children}</Component>;

            case 'span':
            case 'p':
            case 'ul':
            case 'li':
              return (
                <Component key={id} className={textSm}>
                  {children}
                </Component>
              );
            default:
              return <Component key={id}>{children}</Component>;
          }
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (components as any)[tag] = fn;
      }
    } catch (_) {
      // If the tag is not a valid motion component, we skip it
      console.warn(`Skipping invalid motion component for tag: ${tag}`);
    }
  });
  return components;
}
